<template>
    <div :class="['content-box first', addType == 1 ? 'min-full' : '']" style="overflow: visible" v-loading="dataLoading">
        <SongReleaseProgress style="position: absolute; top: -24px; left: 200px"></SongReleaseProgress>
        <AIParse :class="[addType == 1 ? '' : 'hide']" @onSuccess="onRecognize" ref="aiParseView" />
        <el-form v-if="addType == 0 || addType == 2" :model="formData" ref="formData" :rules="rules" label-position="top" :disabled="!isCanEdit">
            <el-row :gutter="60">
                <el-col :span="12">
                    <el-form-item prop="cover" label="封面" :rules="[{required: true, message: '请上传封面'}]">
                        <span class="el-form-item-label-ft ai-cover" v-if="addType == 2" @click="aICoverCandidateVisible = true">
                            AI封面功能 is coming!
                        </span>
                        <ImageUpload
                            :disabled="isEdit"
                            class="album-cover"
                            :minWidth="minWidth"
                            :minHeight="minHeight"
                            :url.sync="formData.cover"
                            :isWatermark="true"
                            :hasWatermark.sync="formData.hasWatermark"
                            accept="image/png,image/jpeg"
                            crop
                            @onSuccess="clearValidate"
                        >
                            <div slot="tips">
                                格式：JPG、JPEG、PNG
                                <br />
                                {{ ImageUploadTips }}
                                <br />
                                大小：不得大于15M
                            </div>
                        </ImageUpload>
                    </el-form-item>
                    <el-form-item label="歌曲源文件" prop="track.path" :rules="[{required: true, message: '请上传歌曲源文件', trigger: 'blur'}]">
                        <AudioUpload
                            ref="audioUploadRef"
                            :disabled="isEdit"
                            :tarckData.sync="formData.track"
                            @id3Update="id3Update"
                            @onSuccess="clearValidate"
                            @footer-state-change="onAudioFooterStateChange"
                        ></AudioUpload>
                    </el-form-item>
                    <div v-if="audioInlineNote" :class="['trackfile-inline-note', audioInlineNote.type]">
                        <i v-if="audioInlineNote.type === 'repairing'" class="el-icon-loading"></i>
                        <span :class="['repair-tag', audioInlineNote.type]">{{ audioInlineNote.tag }}</span>
                        <span>{{ audioInlineNote.text }}</span>
                    </div>
                    <el-form-item prop="remark" label="简介">
                        <el-input :disabled="isEdit" v-model="formData.introduce" type="textarea" placeholder="填写专辑简介" :rows="6"></el-input>
                    </el-form-item>
                    <el-form-item prop="lyrics" label="歌词">
                        <LrcFormat
                            :disabled="isEdit"
                            :lyrics-file-type.sync="lyricsFileType"
                            :aiSync="aiParseJson.parseStatus == 1 && addType == 2 ? true : false"
                            :lrc.sync="formData.lyrics"
                            :src="formData.track.path"
                            @stopAiParse="stopAiParse('parse')"
                        ></LrcFormat>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item prop="track.name" label="名称" :rules="[{required: true, message: '请输入名称'}]">
                        <el-input :disabled="isEdit" v-model="formData.track.name" placeholder="请输入名称" maxlength="250"></el-input>
                    </el-form-item>
                    <el-form-item prop="trackVersion" label="歌曲副标题">
                        <el-select :disabled="isEdit" :clearable="true" v-model="formData.track.trackVersion" placeholder="请选择歌曲副标题">
                            <el-option v-for="(item, index) in trackVersionOptions" :key="index" :label="item" :value="item" />
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="track.langCode" label="表演语言" :rules="[{required: true, message: '请选择表演语言'}]">
                        <div class="ai-loading" v-if="aiParseJson.parseStatus == 1 && addType == 2">
                            <p>AI正在识别中...</p>
                            <el-button type="aiStop" @click="stopAiParse('parse')">
                                <span class="m-icon icon-stop"></span>
                                停止生成
                            </el-button>
                        </div>
                        <el-select :disabled="isEdit" v-model="formData.track.langCode" placeholder="请选择表演语言">
                            <el-option v-for="(item, index) in langCodeOptions" :key="index" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="track.genreId" label="流派/风格" :rules="[{required: true, message: '请选择风格流派'}]">
                        <div class="ai-loading" v-if="aiParseJson.genreStatus == 1 && addType == 2">
                            <p>AI正在识别中...</p>
                            <el-button type="aiStop" @click="stopAiParse('genre')">
                                <span class="m-icon icon-stop"></span>
                                停止生成
                            </el-button>
                        </div>
                        <el-cascader
                            :disabled="isEdit"
                            v-model="formData.track.genreId"
                            :options="genreOptions"
                            :props="{emitPath: false}"
                        ></el-cascader>
                    </el-form-item>
                    <el-form-item prop="track.isAiGenerated" label="是否为AI生成">
                       <el-radio-group v-model="formData.track.isAiGenerated">
                            <el-radio :label="1" border>是</el-radio>
                            <el-radio :label="0" border>否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item prop="dealStartDate" label="期望上线时间">
                        <HolidayDatePicker
                            v-model="formData.dealStartDate"
                            :disabled="isDealStartDateEdit"
                            :editable="false"
                        />
                        <!-- <el-date-picker
                            v-model="formData.dealStartDate"
                            :disabled="isDealStartDateEdit"
                            type="datetime"
                            placeholder="请选择期望上线时间"
                            value-format="timestamp"
                            format="yyyy-MM-dd HH:00"
                            :default-value="new Date(Date.now() + 3 * 24 * 60 * 60 * 1000).getTime()"
                            popper-class="hideDatePicker"
                            @change="onDealStartDate"
                            :picker-options="pickerOptions"
                            style="width: 100%"
                            :editable="false"
                        /> -->
                    </el-form-item>
                    <el-form-item
                        v-if="$store.state.userType == 3"
                        prop="originalReleaseDate"
                        :rules="[{required: true, message: '请选择原始发行日期'}]"
                    >
                        <label slot="label">
                            原始发行日期
                            <p>填写已/将上线的首次日期</p>
                        </label>
                        <el-date-picker
                            v-model="formData.originalReleaseDate"
                            type="datetime"
                            :disabled="isEdit"
                            placeholder="请原始发行时间"
                            value-format="timestamp"
                            format="yyyy-MM-dd HH:00"
                            popper-class="hideDatePicker"
                            style="width: 100%"
                            :editable="false"
                        />
                    </el-form-item>
                    <ArtistSelectCard
                        ref="artistSelectCard"
                        :main-artist.sync="formData.mainArtist"
                        :other-artist.sync="formData.otherArtist"
                        :project-role-artist-info.sync="projectRoleArtistInfo"
                        :third-party-platform-stats.sync="thirdPartyPlatformStats"
                        :if-apple-verify="ifAppleVerify"
                        :disabled="isEdit"
                        :display-lang-code="formData.displayLangCode"
                    ></ArtistSelectCard>
                </el-col>
            </el-row>
            <el-form-item class="submit-footer">
                <div class="footer-btns">
                    <template>
                        <el-button v-if="status === 10" @click="throttledSubmit(1)" :loading="btnLoading" :disabled="isAudioSubmitDisabled">保存</el-button>
                        <el-button v-if="submitReview" type="primary" @click="showChannelDialog()" :loading="btnLoading" :disabled="isAudioSubmitDisabled">提交审核</el-button>
                    </template>
                    <el-button v-if="status == 12" :loading="btnLoading" @click="sendAlbumEdit(1)">发起修改</el-button>
                    <el-button v-if="status == 14" :loading="btnLoading" @click="sendAlbumEdit(2)">撤销修改</el-button>
                </div>
                <div :class="['footer-note', audioFooterNote && audioFooterNote.type]">
                    {{ audioFooterNote && audioFooterNote.text }}
                </div>
            </el-form-item>
        </el-form>
        <ChannelDialog :visible.sync="visible" @onData="onChannelData"></ChannelDialog>
        <IssueService :visible.sync="issueServicevisible" :album-type="1" @onSubmit="onSubmit(2, true)"></IssueService>
        <AICoverCandidate :visible.sync="aICoverCandidateVisible" />
    </div>
</template>

<script>
import AIParse from '../components/Ai/Parse.vue';
import AICoverCandidate from '../components/Ai/CoverCandidate.vue';
import ImageUpload from '@/components/ImageUpload';
import LrcFormat from '@/components/LrcFormat';
import AudioUpload from '@/components/AudioUpload';
import ArtistSelectCard from '../components/ArtistSelectCard';
import ChannelDialog from '../components/ChannelDialog';
import {getLangCode, getGenre, fetchArtistType, checkAppleVerifyInfo} from '@/api/common';
import {uploadLyricByText} from '@/api/file';
import IssueService from '../components/IssueService';
import SongReleaseProgress from '@/components/SongReleaseProgress';
import HolidayDatePicker from '@/components/HolidayDatePicker';

export default {
    props: {
        albumId: {
            type: [Number, String],
            default: '',
        },
    },
    components: {SongReleaseProgress, ImageUpload, ArtistSelectCard, AudioUpload, LrcFormat, ChannelDialog, IssueService, AIParse, AICoverCandidate, HolidayDatePicker},
    data() {
        return {
            dataLoading: false,
            formData: {
                track: {
                    path: '',
                    genreId: null,
                    langCode: null,
                    isAiGenerated: 0,
                },
                cover: '',
                trackArtists: [],
                mainArtist: [],
                otherArtist: [
                    {type: 5, artist: []},
                    {type: 4, artist: []},
                ],
                lyrics: ``,
                hasWatermark: 1,
            },
            pickerOptions: {
                disabledDate(time) {
                    // const deadline = '2023-05-04 00:00:00';
                    let endDate = new Date(Date.now() + 4 * 24 * 60 * 60 * 1000);
                    endDate.setHours(0, 0, 0, 0);
                    //  五一期间不上架
                    // if (endDate.getTime() < new Date(deadline).getTime()) endDate = new Date(deadline);
                    return time.getTime() < endDate.getTime();
                },
            },
            materiels: [],
            lyricsFileType: 2,
            btnLoading: false,
            redirect: this.$route.query.redirect || '/manage/album/list',
            langCodeOptions: [],
            genreOptions: [],
            rules: {
                mainArtist: [{type: 'array', required: true, message: '至少添加一位艺人，主要的演唱艺人'}],
            },
            // 专辑状态 | 未提交 10、待审核 11、 审核通过 12、审核未通过 13、修改中 14、已删除 15、修改待审核 16
            status: 10,
            statusMsg: '',
            visible: false,
            issueServicevisible: false,
            aICoverCandidateVisible: false,
            throttledSubmit: null, // 节流提交函数
            addType: 0, // 0 = 默认  1=AI 2=AI识别中
            aiParseJson: {
                parseStatus: 1,
                genreStatus: 1,
            },
            projectRoleArtistInfo: [],
            ifAppleVerify: false,
            isAudioSubmitDisabled: false,
            audioFooterNote: null,
            audioInlineNote: null,
            thirdPartyPlatformStats: []
        };
    },
    created() {
        // 解析是否是 AI
        const {type} = this.$route.query;
        if (type) this.addType = Number(type);
        this.getConfig();
        if (this.albumId) this.getDataDetail();
        const {issueService} = this.$route.query;
        if (issueService) this.showRenewalService();
        this.throttledSubmit = this.$utils.throttle(this.onSubmit, 3000);
        this.getArtistType(); // 获取艺人类型选项
    },
    beforeRouteLeave(to, from, next) {
        if (this.$refs.audioUploadRef) {
            this.$refs.audioUploadRef.cancel();
        }
        next();
    },
    computed: {
        submitReview() {
            const {status} = this;
            return status === 10 || status === 14 || status === 13;
        },
        // 歌曲版本选项
        trackVersionOptions() {
            return ['现场', 'Demo', 'Remix', 'Remaster', '伴奏'];
        },
        // 专辑是否可以修改（未提交、审核未通过、修改中状态下允许修改）
        isCanEdit() {
            return this.status === 10 || this.status === 13 || this.status === 14 || this.status === 12;
        },
        isEdit() {
            return this.status === 12 ? true : false;
        },
        isDealStartDateEdit() {
            if (this.status === 12) return true;
            if (this.formData.spLinkStatus && this.formData.spLinkStatus !== 0) return true;
            return false;
        },
        ifLimitAlbumForShowStart() {
            return this.$store.state.userData && this.$store.state.userData.ifLimitAlbumForShowStart;
        },
        minWidth() {
            return this.$store.state.userData.userInfo?.coverSetting === 1 ? 500 : 1400;
        },
        minHeight() {
            return this.$store.state.userData.userInfo?.coverSetting === 1 ? 500 : 1400;
        },
        ImageUploadTips() {
            return this.$store.state.userData.userInfo?.coverSetting === 1 ? '尺寸：1:1，不小于500*500像素，但不能超过6000*6000像素' : '尺寸：1:1，不小于1400*1400像素，但不能超过6000*6000像素';
        }
    },
    methods: {
        onAudioFooterStateChange({submitDisabled, footerNote, inlineNote}) {
            this.isAudioSubmitDisabled = submitDisabled;
            this.audioFooterNote = footerNote;
            this.audioInlineNote = inlineNote;
        },
        // 停止AI识别
        stopAiParse(type) {
            const $aiParseView = this.$refs['aiParseView'];
            if ($aiParseView) $aiParseView.updateStatus(type);
        },
        // AI识别歌曲回调
        onRecognize(aiData) {
            const {lyric, langCode, secondGenreId, audio, genreStatus, parseStatus} = aiData;
            this.aiParseJson = aiData;

            if (this.formData.track.path == '') {
                this.formData.track = {...this.formData.track, ...audio, genreId: null, langCode: null};
            }
            if (genreStatus == 2) {
                if (secondGenreId && !this.formData.track.genreId) this.formData.track.genreId = secondGenreId;
            }
            if (parseStatus == 2) {
                if (lyric && !this.formData.lyrics) this.formData.lyrics = lyric;
                if (langCode && !this.formData.track.langCode) this.formData.track.langCode = langCode;
            }
            if (this.addType != 2) this.addType = 2;
        },
        onDealStartDate(val) {
            const dealStartDate = new Date(val);
            this.formData.dealStartDate = dealStartDate.setMinutes(0, 0, 0);
        },
        onRefresh(refreshAlbumId) {
            this.$router.replace({
                path: `/manage/album/singleTrackInfo/info/${refreshAlbumId}`,
                query: {
                    redirect: this.$route.query.redirect || '',
                    issueService: true,
                },
            });
        },
        //返回
        goBack() {
            if (this.redirect) {
                this.$router.push({
                    path: this.redirect,
                });
            } else {
                this.$router.go(-1);
            }
        },
        getDataDetail() {
            this.dataLoading = true;
            this.$request({
                url: '/album/view/album_info',
                params: {albumId: this.albumId},
                method: 'post',
            })
                .then((res) => {
                    const {state, msg, result} = res.data;
                    if (state == 1) {
                        // 艺人
                        const mainArtist = [];
                        const otherArtist = [];

                        // 合并专辑艺人（albumArtists）与单曲艺人（trackArtists），相同 artistId+type 以单曲艺人数据为主
                        const artistMap = new Map();
                        (result.albumVo.albumArtists || []).forEach((item) => {
                            artistMap.set(`${item.artistId}_${item.type}`, item);
                        });
                        (result.trackDtailVo.trackArtists || []).forEach((item) => {
                            artistMap.set(`${item.artistId}_${item.type}`, item);
                        });
                        const mergedTrackArtists = Array.from(artistMap.values());

                        mergedTrackArtists.forEach((item) => {
                            const {artistId, artistName, type} = item;

                            switch (type) {
                                case 1:
                                    mainArtist.push({type, artistId, artistName});
                                    break;
                                default:
                                    {
                                        let o = otherArtist.find((item) => item.type === type);
                                        if (!o) {
                                            o = {type, artist: []};
                                            otherArtist.push(o);
                                        }

                                        o.artist.push({artistId, artistName});
                                    }
                                    break;
                            }
                        });

                        // 现实作词作曲列表
                        if (otherArtist.findIndex((row) => row.type === 5) === -1) {
                            otherArtist.push({type: 5, artist: []});
                        }
                        if (otherArtist.findIndex((row) => row.type === 4) === -1) {
                            otherArtist.push({type: 4, artist: []});
                        }
                        this.formData = {
                            ...this.formData,
                            ...result.albumVo.album,
                            albumId: parseInt(this.albumId),
                            lyrics: result.trackDtailVo.lyricsDetail,
                            track: {
                                ...result.trackDtailVo.track,
                                isAiGenerated: result?.trackDtailVo?.track?.isAiGenerated || 0
                            },
                            mainArtist: mainArtist,
                            otherArtist: otherArtist,
                        };
                        if (result.trackDtailVo.materiels && result.trackDtailVo.materiels.length > 0) this.materiels = result.trackDtailVo.materiels;
                        // 问题：后端修改introduce专辑简介不会同步到歌曲的remark字段上，前端修改歌曲的remark字段会同步到专辑introduce上面
                        // 为了保证后端不修改逻辑前端重新赋值一次
                        this.status = result.albumVo.album.status;
                        this.statusMsg = res.data.result.alertInfo;
                        this.thirdPartyPlatformStats = result.allThirdPartyPlatformStats || [];
                    } else {
                        this.$message.error(msg || '获取数据失败,请重试');
                    }
                })
                .catch(() => {
                    this.$message.error('获取数据失败,请重试');
                })
                .finally(() => {
                    this.dataLoading = false;
                    this.checkAppleVerifyInfo();
                    this.isAudioSubmitDisabled = false;
                    this.audioFooterNote = null;
                    this.audioInlineNote = null;
                });
        },
        // 清除验证
        clearValidate(data) {
            if (this.formData.cover) this.formData.coverS = data.urlS;
            this.$refs['formData'].clearValidate();
        },
        async getConfig() {
            this.langCodeOptions = await getLangCode(); //获取表演语言
            this.genreOptions = await getGenre(); //获取风格
        },
        artistChange() {
            let _artists = [...this.formData.mainArtist];
            this.formData.otherArtist.map((item) => {
                if (item.type) {
                    item.artist.map((v) => {
                        _artists.push({
                            ...v,
                            type: item.type,
                        });
                    });
                }
            });
            _artists.map((item, index) => {
                item.sort = index;
            });
            this.formData.trackArtists = [..._artists];
        },
        // 更新ID3信息
        async id3Update(meta) {
            // const res = await fetchId3Info({...meta, displayLangCode: 'zh'});
            // const {genreId} = res.data.result;
            if (!this.formData.lyrics && meta.lyrics) {
                this.formData.lyrics = meta.lyrics;
            }
            if (!this.formData.track.name && meta.name) {
                this.formData.track.name = meta.name;
            }
            // if( !this.formData.track.genreId && genreId ){
            //     this.formData.track.genreId = genreId;
            // }
        },
        onChannelData(spIds) {
            this.formData.excludeSpIds = spIds;
            this.throttledSubmit(2);
        },
        // 显示续费服务弹窗
        showRenewalService() {
            const {userType} = this.$store.state;
            // 个人还是企业
            if (userType == 1) {
                return (this.issueServicevisible = true);
            } else {
                return this.$confirm('您的发行服务已经到期，目前企业发行续费服务已经停止，请联系客服进行专辑修改', '温馨提示', {
                    confirmButtonText: '知道了',
                    showCancelButton: false,
                    center: true,
                    type: 'warning',
                });
            }
        },
        showChannelDialog() {
            const {userState} = this.$store.getters;

            if (this.ifLimitAlbumForShowStart == 1 || this.formData.ifOnlyReleaseSs == 1) {
                //未付费秀动用户直接提交
                this.throttledSubmit(2);
            } else {
                if (userState != 6) {
                    // 新增单曲
                    if (!this.albumId && userState != 3) {
                        this.throttledSubmit(1, false);
                        return (this.issueServicevisible = true);
                    }
                    // 编辑单曲
                    if (this.albumId && !this.formData.isExperience) {
                        if (userState <= 5) {
                            this.throttledSubmit(1, false);
                            this.showRenewalService();
                        }
                    }
                }
                this.artistChange();
                // v1.4.2
                const {trackArtists, track} = this.formData;
                if (trackArtists) {
                    const hasType =
                        track.langCode === 'cyy'
                            ? trackArtists.some((item) => item.type === 5)
                            : trackArtists.some((item) => item.type === 4) && trackArtists.some((item) => item.type === 5);
                    if (!hasType) return this.$message.error(track.langCode === 'cyy' ? '请填写作曲人' : '请填写作词人、作曲人');
                }
                this.$refs['formData'].validate((valid) => {
                    if (valid) this.visible = true;
                });
            }
        },
        //表单提交
        onSubmit(type, isGoBack = true) {
            this.artistChange();
            this.$refs['formData'].validate(async (valid) => {
                if (valid) {
                    this.btnLoading = true;
                    if (this.formData.lyrics) {
                        const lrc = await uploadLyricByText({
                            lyricsDetail: this.formData.lyrics,
                            lyricsFileType: this.lyricsFileType,
                            id: this.materiels.length > 0 ? this.materiels[0].id : '',
                        });
                        const {fileName, url} = lrc.data.result;
                        this.formData.materiels = [
                            {
                                materielName: fileName,
                                materielPath: url,
                                materielType: 7,
                            },
                        ];
                    }
                    //CP设置了 AppleMusic曲库校验套件：
                    // if (this.ifAppleVerify) {
                    //     if(this.hasProject(this.formData.otherArtist, this.projectRoleArtistInfo)){
                    //         this.$message.error('工程制作人员必须填写一位');
                    //         this.btnLoading = false;
                    //         return false;
                    //     }
                    // }
                    let _formData = {...this.formData};
                    delete _formData.otherArtist;
                    delete _formData.mainArtist;

                    this.$request({
                        url: type === 2 ? '/album/up/commit_singletrackalbum_forshowstart' : '/album/saveSingleTrackAlbum',
                        method: 'POST',
                        data: {
                            ..._formData,
                        },
                        formData: false,
                    }).then((res) => {
                        //处理成功回调
                        const {state, msg, result} = res.data;
                        if (state && state == 1) {
                            if (isGoBack) {
                                if (type === 2) {
                                    this.$confirm(`我们将在3-5个工作日内完成审核。`, '已成功提交审核', {
                                        type: 'success',
                                        dangerouslyUseHTMLString: true,
                                        center: true,
                                        showCancelButton: false,
                                        showClose: false,
                                        confirmButtonClass: 'el-button--info',
                                        closeOnClickModal: false,
                                        confirmButtonText: `返回列表`,
                                    }).then(() => {
                                        this.goBack();
                                    });
                                } else {
                                    this.goBack();
                                }
                            } else {
                                this.onRefresh(result);
                            }
                        } else {
                            this.btnLoading = false;
                            return this.$message.error(msg || '操作失败');
                        }
                    });
                }
            });
        },
        // 发起\撤销修改
        async sendAlbumEdit(type) {
            if (type == 1) {
                const flag = await this.$confirm(
                    this.albumStatus == 4 ? '可能会让你修改后的信息，无法及时同步到各个平台' : '发起修改后，可能会影响正常上线时间',
                    '修改专辑',
                    {
                        center: true,
                        confirmButtonText: '确认修改',
                    }
                );
                if (flag === 'cancel') return;
            }
            this.btnLoading = true;
            this.$request({
                url: this.status == 12 ? '/album/up/launch' : '/album/up/cancel',
                method: 'POST',
                data: {albumId: this.albumId},
            })
                .then((res) => {
                    //处理成功回调
                    const {state, msg} = res.data;
                    if (state && state == 1) {
                        this.getDataDetail();
                    } else {
                        return this.$message.error(msg || '操作失败');
                    }
                })
                .finally(() => {
                    this.btnLoading = false;
                });
        },
        async checkAppleVerifyInfo() {
            const res = await checkAppleVerifyInfo({cpId: this.formData?.cpId, verifyType: 100});
            const {state, msg, result} = res.data;
            if (!state) {
                return this.$message.error(msg);
            } else {
                if (result.ifAppleVerify == 1) {
                    this.ifAppleVerify = true;
                }
            }
        },
        async getArtistType() {
            try {
                const res = await fetchArtistType();
                const {state, result} = res.data;
                if (state && result) {
                    this.projectRoleArtistInfo = result.filter(item => item.classType == 2).map(item => ({label: item.name, value: item.value}));
                }
            } catch (error) {
                this.$message.error('获取艺人类型失败');
            }
        },
        //只要 “工程制作人员”分组角色任意填写一个即可通过校验
        hasProject(otherArtist, projectRoleArtist){
            const project = new Set(projectRoleArtist.map(item => item.value));
            for (const item of otherArtist) {
                if (Array.isArray(item.artist) && item.artist.length > 0) {
                    if (project.has(item.type)) {
                        return false;
                    }
                }
            }
            return true;
        }
    },
};
</script>
<style lang="scss">
.submit-footer {
    display: flex;
    align-items: center;
    padding: 0 20px;

    .el-form-item__content {
        display: flex;
        align-items: center;
        width: 100%;
    }
}

.footer-btns {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
}

.footer-note {
    font-size: 12px;
    line-height: 20px;
    margin-left: 16px;
    white-space: nowrap;

    &.warning {
        color: #e6a23c;
    }

    &.danger {
        color: #f56c6c;
    }
}

.trackfile-inline-note {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    line-height: 20px;
    margin-top: -18px;
    margin-bottom: 18px;
    padding-left: 0;

    .el-icon-loading {
        font-size: 14px;
    }

    &.repairing {
        color: #e6a23c;

        .el-icon-loading {
            color: #e6a23c;
        }
    }

    &.repaired {
        color: #606266;
    }

    &.failed {
        color: #f56c6c;
    }
}

.repair-tag {
    display: inline-block;
    padding: 1px 8px;
    border-radius: 10px;
    font-size: 12px;
    line-height: 18px;
    vertical-align: middle;
    margin-right: 2px;

    &.repaired {
        color: #175cd3;
        background: #eff8ff;
        border: 1px solid #b2ddff;
    }

    &.repairing {
        color: #b54708;
        background: #fffaeb;
        border: 1px solid #fedf89;
    }

    &.failed {
        color: #b42318;
        background: #fef3f2;
        border: 1px solid #fda29b;
    }
}

.el-form-item-label-ft {
    position: absolute;
    top: -50px;
    right: 0px;
}

.ai-cover {
    background: linear-gradient(32.86461690810346deg, #ff92e3 0%, #ffab82 20%, #7f98ff 44%, #be85ff 67%, #33e8e0 100%);
    background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: bold;
    cursor: pointer;
}

.ai-loading {
    height: 44px;
    background: #fafbfd;
    border-radius: 4px;
    border: 3px solid;
    border-image: linear-gradient(
            135deg,
            rgba(253, 187, 236, 1),
            rgba(252, 193, 164, 1),
            rgba(172, 188, 254, 1),
            rgba(229, 206, 255, 1),
            rgba(168, 241, 255, 1)
        )
        3 3;
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    display: flex;
    justify-content: space-between;
    z-index: 9;

    p {
        padding-left: 15px;
    }

    .el-button {
        margin: 4px;

        .icon-stop {
            background: url('~@/assets/img/stop.svg') no-repeat center;
            background-size: cover;
            width: 10px;
            height: 10px;
            display: inline-block;
        }
    }
}
</style>
